define(['jquery'], function ($) {

	var ERVFormatting = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
	};

	ERVFormatting.prototype.reverseShortDate = function (date, dayFirst) {
		var dateArr = date.split('-');
		if (dateArr.length === 3) {
			if (dayFirst) {
				//2017-12-24 -> 24-12-2017
				date = dateArr[0] + '-' + dateArr[1] + '-' + dateArr[2];
			} else {
				//24-12-2017 -> 2017-12-24
				date = dateArr[2] + '-' + dateArr[1] + '-' + dateArr[0];
			}
		}

		return date;
	};

	return ERVFormatting;
});